/**
 * Global constants shared between module (or between a module and `shared` folder)
 */

export const LAYOUT_HEADER_Z_INDEX = 1;

export const UNCLASSIFIED = 'unclassified';

export const CSV_IMPORT = 'csv_import';
export const UNIFIED_ORG_CHARTS = 'unified_org_charts';
export const AI_ASSISTANT = 'ai_assistant';
export const ESSENTIAL = 'decision_essential';
export const FINANCE_SOFTWARE_SWITCH = 'finance_software_switch';
export const ANONYMIZED = 'anonymized';
export const PUBLIC_API = 'public_api';
export const PHASE_BLOCKS = 'phase_blocks';
